const topics = {};

export const subscribe = (topic, func) => {

  if (!topics[topic]) topics[topic] = [];

  return topics[topic].push({ func });
};

/* istanbul ignore next */
export const unsubscribe = topic => delete topics[topic];

export const publish = (topic, args) => {

  const subscribers = topics[topic];
  if (!subscribers) return false;

  subscribers.forEach((subscriber) => {
    subscriber.func(topic, args);
  });

  return true;
};



// WEBPACK FOOTER //
// ./src/pubsub.js